









import Vue from 'vue';

export default Vue.extend({
	name: 'ParameterIssues',
	props: [
		'issues',
	],
});
